import { apiFetchJson } from './apiClient';

export type MarketReferenceIndustry = {
  id: number;
  name: string;
};

export type MarketReferenceSector = {
  id: number;
  industryId: number;
  name: string;
};

export type MarketReferencePayload = {
  industries: MarketReferenceIndustry[];
  sectors: MarketReferenceSector[];
};

export async function fetchMarketReference(): Promise<MarketReferencePayload> {
  const res = await apiFetchJson<{ data: MarketReferencePayload }>('GET', '/market/reference');
  if (!res.ok) throw new Error(res.error);
  return res.data.data ?? { industries: [], sectors: [] };
}
